module.exports = "/assets/98978c4376ad15d7ee227bb7e87a8d3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/5J.png
// module id = 2191
// module chunks = 0